import useGenerateImageUploadUrls from '@/hooks/useGenerateImageUploadUrls';
import useUploadImage from '@/hooks/useUploadImage';
import {
  type AvatarUploadRequest,
  uploadAvatars as uploadAvatarsWith,
  uploadAvatar as uploadAvatarWith,
} from '@/utils/uploadAvatar';

type UploadAvatarInput = Omit<AvatarUploadRequest, 'key'>;

export default function useAvatarUploader() {
  const generateImageUploadUrls = useGenerateImageUploadUrls();
  const uploadImage = useUploadImage();

  const uploadAvatar = ({ localUrl, path }: UploadAvatarInput) =>
    uploadAvatarWith({
      generateImageUploadUrls,
      localUrl,
      path,
      uploadImage,
    });

  const uploadAvatars = (requests: AvatarUploadRequest[]) =>
    uploadAvatarsWith({ generateImageUploadUrls, requests, uploadImage });

  return { uploadAvatar, uploadAvatars };
}
